import { Share2 } from 'lucide-react';

function XIcon({ size = 15 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}

export default function ShareButtons({ coffee }) {
  const url = window.location.href;
  const text = `${coffee.name} @ ${coffee.cafe_name} — on Signature Coffee Note`;

  const shareX = () => {
    window.open(
      `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`,
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <div className="space-y-1.5">
      <button
        onClick={shareX}
        className="w-full flex items-center justify-center gap-2 py-3 border border-border rounded-2xl font-medium text-sm text-foreground hover:border-foreground/30 active:scale-[0.98] transition-all"
      >
        <XIcon />
        Share on X
      </button>
      <p className="flex items-center gap-1.5 text-[11px] text-muted-foreground">
        <Share2 size={11} />
        Shared posts use the app's social image.
      </p>
    </div>
  );
}